import axios from 'axios'

const API_URL = 'https://elana-api.herokuapp.com/api/users/'

//post user
const createUser = async (data) => {
   
    const response = await axios.post(`${API_URL}register`, data)

    return response.data
}

// Get user
const getUser = async () => {
   
    const response = await axios.get(API_URL)

    return response.data
}

const userService = {
    createUser, getUser,
}

export default userService